import qs from 'qs'
import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class InspectionService extends Service {
  path = 'vistoria'

  async get(
    perPage: number,
    page: number,
    sortField: string = '',
    sortAscending: boolean = true,
    params?: any
  ) {
    const payloadSubmitted = {
      'Pagination.PageSize': perPage,
      'Pagination.Page': page,
      'Pagination.SortField': sortField,
      'Pagination.SortAscending': sortAscending,
      ...params
    }

    const httpResponse = await this.httpClient.get(this.path, {
      params: payloadSubmitted,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      }
    })
    return httpResponse
  }

  async getHistoric(params: any) {
    const httpResponse = await this.httpClient.get(
      `/${this.path}/obterHistorico?vistoriaId=${params?.id ?? ''}&pageSize=${
        params?.perPage
      }&page=${params?.page}`
    )
    return httpResponse
  }

  async getSerialItems(id: any) {
    const httpResponse = await this.httpClient.get(
      `/${this.path}/obteritensseries?vistoriaId=${id ?? ''}`
    )
    return httpResponse
  }

  async decline(params: any) {
    const httpResponse = await this.httpClient.post(
      `/${this.path}/reprovar`,
      params
    )
    return httpResponse
  }

  async changeStatus(params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `/statusVeiculo`,
      params
    )
    return httpResponse
  }

  async download(params?: any) {
    const httpResponse = await this.httpClient.get(`vistoria/excel`, {
      params: removePropertyEmpty(params),
      paramsSerializer: (params) => {
        return qs.stringify(params)
      }
    })
    return httpResponse
  }

  async cancelInspection(params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/cancelarvistoria?vistoriaId=${params.id}`,
      { motivo: params.motive }
    )
    return httpResponse
  }

  async requestEditInspection(params: any) {
    const httpResponse = await this.httpClient.post(
      `/${this.path}/solicitaredicao?vistoriaId=${params.id}`,
      { motivo: params.justification }
    )
    return httpResponse
  }

  async postFrota(params: any) {
    const httpResponse = await this.httpClient.post(
      `/${this.path}/frota`,
      params
    )
    return httpResponse
  }

  async putOwner(id: string, params: any) {
    const httpResponse = await this.httpClient.put(
      `/proprietario?proprietarioId=${id}`,
      params
    )
    return httpResponse
  }

  async postOwner(params: any) {
    const httpResponse = await this.httpClient.post(`/proprietario`, params)
    return httpResponse
  }

  async postSurvey(params: any) {
    Object.getOwnPropertyNames(params).forEach(function (prop) {
      if (!params[prop]) delete params[prop]
    })

    const httpResponse = await this.httpClient.post(`/vistoria`, params)
    return httpResponse
  }

  async putSituation(id: string) {
    const httpResponse = await this.httpClient.post(
      `/vistoria/finalizar?vistoriaId=${id}`
    )
    return httpResponse
  }

  async put(id: string, params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}?vistoriaId=${id}`,
      params
    )
    return httpResponse
  }

  async getSignature(id: string) {
    const httpResponse = await this.httpClient.get(
      `/${this.path}/obterassinaturas?vistoriaId=${id}`
    )
    return httpResponse
  }

  async getInspectionListByIds(params: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/vistorialote`,
      params
    )
    return httpResponse
  }

  async getInspectionById(id: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/${id}`)
    return httpResponse
  }

  async cloneInspection(params: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/clonar`,
      params
    )
    return httpResponse
  }

  async exportHistory(params: any) {
    const httpResponse = await this.httpClient.get(
      `${this.path}/historico/excel`,
      {
        params: removePropertyEmpty(params)
      }
    )

    return httpResponse
  }
}

export const inspectionService = new InspectionService()
